__turbopack_context__.v({
  "columns": "common-module__n_nFqG__columns",
  "error": "common-module__n_nFqG__error",
  "fullSizeBlock": "common-module__n_nFqG__fullSizeBlock",
  "grid": "common-module__n_nFqG__grid",
});
